import { reducers } from 'redux/core'
import request from 'local_modules/request'
import { constants } from 'helpers'


const fetchBuses = (type) => {
  if (type === 'violation') {
    return request.get(constants.lscTransportControl.violationsBuses)
      .then(({ data }) =>
        reducers.lscTransportControl.filters.setList({ data: data.map(({ busNumber }) => busNumber), listName: 'buses' })
      )
  }

  if (type === 'deviation') {
    return request.get(constants.lscTransportControl.deviationsBuses)
      .then(({ data }) =>
        reducers.lscTransportControl.filters.setList({ data: data.map(({ busNumber }) => busNumber), listName: 'buses' })
      )
  }

  return request.get(constants.lscTransportControl.busNumbers)
    .then(({ data }) =>
      reducers.lscTransportControl.filters.setList({ data: data.map((buses) => buses[0]), listName: 'buses' })
    )
}

const fetchDates = () =>
  request.get('/data/dates')
    .then(({ data }) =>
      reducers.lscTransportControl.filters.setList({ data: data, listName: 'dates' })
    )

const fetchRoutes = (type) => {
  if (type === 'violation') {
    return request.get(constants.lscTransportControl.violationRoutes)
      .then(({ data }) => {
        reducers.lscTransportControl.filters.setList({ data: data.map(({ routeNumber }) => routeNumber), listName: 'routes' })
      })
  }

  if (type === 'deviation') {
    return request.get(constants.lscTransportControl.deviationsRoutes)
      .then(({ data }) => {
        reducers.lscTransportControl.filters.setList({ data: data.map(({ routeNumber }) => routeNumber), listName: 'routes' })
      })
  }

  return request.get(constants.lscTransportControl.routeNumbers)
    .then(({ data }) => {
      reducers.lscTransportControl.filters.setList({ data: data.map(({ routeNumber }) => routeNumber), listName: 'routes' })
    })
}

const clear = ({ type }) => reducers.lscTransportControl.filters.clear({ type })

const setDate = ({ type, data: { from, to } }) => {
  reducers.lscTransportControl.filters.setDate({
    type,
    data: {
      from,
      to,
    },
  })
}

const setContractor = ({ type, data }) => {
  reducers.lscTransportControl.filters.setContractor({
    type,
    data,
  })
}

const setBus = ({ type, data }) => {
  reducers.lscTransportControl.filters.setBus({
    type,
    data,
  })
}

const setRoute = ({ type, data }) => {
  reducers.lscTransportControl.filters.setRoute({
    type,
    data,
  })
}


export default {
  fetchBuses,
  fetchDates,
  fetchRoutes,

  clear,
  setDate,
  setBus,
  setRoute,
  setContractor,
}
